import { Button } from 'react-bootstrap';
import { MouseEvent } from 'react';
import ProcessingGroup from '../ProcessingGroup';

type Props = {
    buttonType?: 'submit' | 'button' | 'reset';
    buttonText?: string;
    processing?: boolean;
    className?: string;
    variant?: string;
    onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
    disabled?: boolean;
}

export default function Submit({ 
    buttonType = 'submit',
    buttonText = 'Submit', 
    processing = false,
    className = '',
    variant = 'primary',
    onClick = () => {},
    disabled = false,
}: Props) {

    return (
        <ProcessingGroup processing={processing} className={`width-auto ${className}`} variant={variant}>
            <Button 
                variant={variant}
                type={buttonType} 
                disabled={disabled || processing}
                onClick={(event) => onClick?.(event)}
            >
                {buttonText}
            </Button>
        </ProcessingGroup>
    );
}